import { Action, createReducer, on } from '@ngrx/store';
import * as Actions from './activity-registry.actions';
import { ActivityRegisterBackendData, ActivityRegisterBackendEventType, ActivityRegisterBackendOperationType, ActivityRegisterFrontendData, ActivityRegisterFrontendEventType, ActivityRegisterFrontendOperationType, ActivityRegisterFrontendState, ActivityRegisterState } from '@core/models/swagger/activityRegistry';

export type State = ActivityRegisterState;

export const featureKey = 'activityRegistry';

const getActivityRegisterInitialState = (): ActivityRegisterState => ({
  projectId: 'qb-ar-deu',
  sessionId: '',
  step: {
    stepBasic: '',
    stepCommon: '',
    stepDescription: '',
    stepNumber: '',
  },
  type: '',
  operationType: '',
});
export const initialState: ActivityRegisterState = getActivityRegisterInitialState();

export function activityRegistryReducer(state: State | undefined, action: Action): State {
  return createReducer(
    initialState,
    on(Actions.UpdateDeviceInformation, (state, { data }) => ({
      ...state,
      operationType: ('browser metadata' as ActivityRegisterFrontendOperationType),
      type: ('EVENT_PAGE' as ActivityRegisterFrontendEventType),
      data: {
        ...(state.data as ActivityRegisterFrontendData),
        deviceInfo: {
          ...data.deviceInfo,
        },
      },
    })),
    on(Actions.UpdateServiceInformation, (state, { data }) => ({
      ...state,
      operationType: ('services traces' as ActivityRegisterBackendOperationType),
      type: ('BACK' as ActivityRegisterBackendEventType),
      data: {
        ...(state.data as ActivityRegisterBackendData),
        serviceInfo: {
          ...data.serviceInfo,
        },
      },
    })),
    on(Actions.UpdateAddressInformation, (state, { data }) => ({
      ...state,
      operationType: ('flow information' as ActivityRegisterFrontendOperationType),
      type: ('COMPONENT_EVENT' as ActivityRegisterFrontendEventType),
      data: {
        ...(state.data as ActivityRegisterFrontendData),
        addressInfo: {
          ...(state.data as ActivityRegisterFrontendData).addressInfo,
          ...data,
        },
      },
    })),
    on(Actions.UpdateOffersInformation, (state, { data }) => ({
      ...state,
      operationType: ('flow information' as ActivityRegisterFrontendOperationType),
      type: ('COMPONENT_EVENT' as ActivityRegisterFrontendEventType),
      data: {
        ...(state.data as ActivityRegisterFrontendData),
        offerInfo: data.offerInfo,
      },
    })),
    on(Actions.UpdateStepInformation, (state, { data }) => ({
      ...state,
      operationType: ('flow information' as ActivityRegisterFrontendOperationType),
      type: ('COMPONENT_EVENT' as ActivityRegisterFrontendEventType),
      step: {
        stepBasic: data.stepBasic,
        stepDescription: data.stepDescription,
        stepNumber: data.stepNumber,
        stepCommon: data.stepCommon,
      },
      data: {
        ...(state.data as ActivityRegisterFrontendData),
        flowInfo: {
          flowName: data.flowName,
          componentName: data.componentName,
          isModalOpen: data.isModalOpen,
        },
      },
    })),
    on(Actions.UpdateSessionId, (state, { data }) => ({
      ...state,
      sessionId: data
    })),
    on(Actions.UpdateIsModalOpen, (state, { data }) => ({
      ...state,
      operationType: ('flow information' as ActivityRegisterFrontendOperationType),
      type: ('COMPONENT_EVENT' as ActivityRegisterFrontendEventType),
      data: {
        ...(state.data as ActivityRegisterFrontendData),
        flowInfo: {
          ...(state.data as ActivityRegisterFrontendData).flowInfo,
          isModalOpen: data,
        },
      },
    })),
    on(Actions.ResetActivityRegistry, _ => (getActivityRegisterInitialState())),
  )(state, action);
}
